

<p-confirmDialog />

<div class="plan-page-container">
  <div class="plan-page-header">
    <h3 class="m-0">Decision Log</h3>
    <p-button
      label="Add"
      icon="pi pi-plus"
      (onClick)="showAddItemDialog()"
      severity="info"
      [rounded]="true" />
  </div>

  <p-table
    [scrollable]="true"
    scrollHeight="flex"
    [value]="items"
    [loading]="loading"
    [paginator]="items.length > 10"
    [rows]="10"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [rowsPerPageOptions]="[10, 20, 50]"
    [tableStyle]="{ 'min-width': '100%' }"
    styleClass="p-datatable no-column-lines compact-striped-table table-scroll-both decision-log-table">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 100px; text-align: center;">
          Number
        </th>
        <th class="col-status">Date</th>
        <th>Decision Taken</th>
        <th style="width: 150px">Owner</th>
        <th>Comments</th>
        <th class="th-actions" style="width: 100px">Actions</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item>
      <tr>
        <td style="text-align: center;">
            {{ item.number }}
        </td>
        <td>{{ formatDate(item.date) }}</td>
        <td class="td-truncate" [pTooltip]="item.decisionTaken || '-'" tooltipPosition="top">{{ item.decisionTaken || '-' }}</td>
        <td>{{ item.owner }}</td>
        <td>{{ item.comments || '-' }}</td>
        <td class="table-cell-actions">
          <div class="table-actions-stack">
            <p-button
              icon="pi pi-pencil"
              (onClick)="showEditItemDialog(item)"
              [text]="true"
              severity="info"
              size="small"
              pTooltip="Edit"
              tooltipPosition="top" />
            <p-button
              icon="pi pi-trash"
              (onClick)="deleteItem(item)"
              [text]="true"
              severity="danger"
              size="small"
              pTooltip="Delete"
              tooltipPosition="top" />
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr class="table-empty-row">
        <td colspan="6" class="table-empty-cell">
          <div class="empty-state">
            <div class="empty-icon"><i class="pi pi-inbox"></i></div>
            <p class="empty-message">No decision log items found</p>
            <p class="empty-description">Click "Add" to create a new decision log item</p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- Item Dialog -->
<p-dialog
  [visible]="displayItemDialog"
  (visibleChange)="displayItemDialog = $event"
  [header]="isEditItemMode ? 'Edit Decision Log Item' : 'Add Decision Log Item'"
  [modal]="true"
  styleClass="dialog-lg"
  [dismissableMask]="true"
  [closable]="true">
  <div class="form-dialog-form form-dialog-compact" *ngIf="selectedItem">
    <div class="form-dialog-container">
      <div class="form-row two-columns">
        <div class="field">
          <label for="number">Number <span class="required-star">*</span></label>
          <input pInputText id="number" [(ngModel)]="selectedItem.number" placeholder="Enter number" required />
        </div>
        <div class="field" [class.field-invalid]="fieldTouched['owner'] && !selectedItem.owner.trim()">
          <label for="owner">Owner <span class="required-star">*</span></label>
          <input pInputText id="owner" [(ngModel)]="selectedItem.owner" placeholder="Enter owner" required (blur)="fieldTouched['owner'] = true" />
          <small class="field-error" *ngIf="fieldTouched['owner'] && !selectedItem.owner.trim()">Owner is required</small>
        </div>
      </div>
      <div class="form-row">
        <div class="field">
          <label for="date">Date <span class="required-star">*</span></label>
          <p-datepicker id="date" [(ngModel)]="decisionDate" [showIcon]="true" dateFormat="D, M d, yy"
            placeholder="Select date" [showButtonBar]="true" appendTo="body" [showOnFocus]="false" [autoZIndex]="true" />
        </div>
      </div>
      <div class="form-row">
        <div class="field" [class.field-invalid]="fieldTouched['decisionTaken'] && !selectedItem.decisionTaken.trim()">
          <label for="decisionTaken">Decision Taken <span class="required-star">*</span></label>
          <textarea pInputText id="decisionTaken" [(ngModel)]="selectedItem.decisionTaken" rows="3"
            placeholder="Enter decision taken..." required class="p-inputtext" (blur)="fieldTouched['decisionTaken'] = true"></textarea>
          <small class="field-error" *ngIf="fieldTouched['decisionTaken'] && !selectedItem.decisionTaken.trim()">Decision taken is required</small>
        </div>
      </div>
      <div class="form-row">
        <div class="field">
          <label for="comments">Comments</label>
          <textarea pInputText id="comments" [(ngModel)]="selectedItem.comments" rows="3" placeholder="Enter comments..." class="p-inputtext"></textarea>
        </div>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns">
      <p-button label="Reset" icon="pi pi-refresh" (onClick)="resetItemForm()" [text]="true" severity="secondary" styleClass="btn-form-reset" />
      <p-button label="Cancel" icon="pi pi-times" (onClick)="displayItemDialog = false" severity="secondary" [outlined]="true" />
      <p-button label="Save" icon="pi pi-check" (onClick)="saveItem()" severity="primary"
        [disabled]="!selectedItem || !selectedItem.decisionTaken.trim() || !selectedItem.owner.trim()" />
    </div>
  </ng-template>
</p-dialog>

